export type MassnahmeCalc<Fields> = { label: string; fields: Fields | null } | null

export function autofillReady<Fields>(
  massnahmeLabel: string,
  calc: MassnahmeCalc<Fields>,
): boolean {
  return massnahmeLabel === '' || calc?.label === massnahmeLabel
}

export function pickEnde(calcEnde: string | null, maxEnde: string | null): string | null {
  if (calcEnde && maxEnde) return maxEnde < calcEnde ? maxEnde : calcEnde
  return calcEnde ?? maxEnde
}
